// Базовые утилиты для процедурной генерации SVG-иконок.
// Стиль: тёмное фэнтези + морская тема, толстые обводки (читаемость на 360px), золотые рамки.

export const PALETTE = {
  gold: '#e0b44c',
  goldDark: '#9c7424',
  wood: '#6b4423',
  woodDark: '#3b2716',
  stone: '#8a8f98',
  stoneDark: '#4c5058',
  parchment: '#ead7a8',
  sea: '#2a6f93',
  seaDark: '#123349',
  crimson: '#a33a3a',
  emerald: '#3c9a62',
  ink: '#1b1410',
  silver: '#cfd6de',
  iron: '#6f7a86',
  sky: '#86bfe0',
  purple: '#8c5bd6',
  blue: '#4a8fe0',
  orange: '#f08c2a',
  white: '#f7f1e3',
} as const;

export const RARITY_COLORS: Record<string, string> = {
  common: '#9aa0a8',
  rare: '#4a8fe0',
  epic: '#a35bf0',
  legendary: '#f39a26',
};

/** Рамка по уровню: бронза → серебро → золото → легендарная. */
export function levelFrame(level: number): string {
  if (level >= 20) return '#f39a26';
  if (level >= 10) return PALETTE.gold;
  if (level >= 5) return PALETTE.silver;
  return '#b07a4a';
}

function esc(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
}

/** Оборачивает содержимое в SVG с aria-label (доступность). */
export function svg(body: string, label: string, size = 64): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="${size}" height="${size}" role="img" aria-label="${esc(
    label,
  )}"><title>${esc(label)}</title>${body}</svg>`;
}

/** Круглая подложка с градиентом и рамкой. */
export function badge(id: string, from: string, to: string, frame: string): string {
  return `<defs><radialGradient id="g${id}" cx="50%" cy="35%" r="70%"><stop offset="0" stop-color="${from}"/><stop offset="1" stop-color="${to}"/></radialGradient></defs><circle cx="32" cy="32" r="29" fill="url(#g${id})" stroke="${frame}" stroke-width="3"/>`;
}

/** Квадратная подложка (предметы, здания). */
export function tileFrame(id: string, from: string, to: string, frame: string): string {
  return `<defs><linearGradient id="t${id}" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${from}"/><stop offset="1" stop-color="${to}"/></linearGradient></defs><rect x="3" y="3" width="58" height="58" rx="10" fill="url(#t${id})" stroke="${frame}" stroke-width="3"/>`;
}

export function levelBadge(level: number): string {
  if (level <= 0) return '';
  return `<circle cx="51" cy="51" r="10" fill="${PALETTE.ink}" stroke="${levelFrame(level)}" stroke-width="2.5"/><text x="51" y="55.5" font-family="Georgia,serif" font-size="12" font-weight="700" text-anchor="middle" fill="${PALETTE.white}">${level}</text>`;
}

export function toDataUri(svgString: string): string {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`;
}

/** Детерминированный короткий id из строки — для уникальных id градиентов. */
export function uid(s: string): string {
  let h = 5381;
  for (let i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) >>> 0;
  return h.toString(36);
}
